import React, { useContext, useState } from 'react';
import StandardRapport from '../../../_StandardRapport/StandardRapport';
import { rapportInfos } from '../../../_Common/Const/RapportInfo';
import EDRadioGroup, {
  IRadioDef,
} from '../../../../../BaseComponents/RadioGroup/EDRadioGroup';
import EDGrid from '../../../../../BaseComponents/GridComponents/EDGrid';
import EDTypography from '../../../../../BaseComponents/Typography/EDTypography';
import { RapportQuery } from '../../../_StandardRapport/Queries/RapportQuery/RapportQuery';
import { ActiveDatabaseContext } from '../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import {
  RapportSettings,
  useReadRapportSettings,
  useWriteRapportSettings,
} from '../../../_StandardRapport/StandardRapportSettings';

export enum EtikettTypEnum {
  Kista = 'Kista',
  Urna = 'Urna',
  QRpersnr = 'QRpersnr',
  QRnamn = 'QRnamn',
  MLsmal = 'MLsmal',
  MLbred = 'MLbred',
}

const radioDefs: IRadioDef[] = [
  {
    label: 'Kistetikett (60x90)',
    value: EtikettTypEnum.Kista,
  },
  {
    label: 'Urnetikett (30x90)',
    value: EtikettTypEnum.Urna,
  },
  {
    label: 'QRkod med persnr',
    value: EtikettTypEnum.QRpersnr,
  },
  {
    label: 'QRkod med namn',
    value: EtikettTypEnum.QRnamn,
  },
  {
    label: 'ML (30x90)',
    value: EtikettTypEnum.MLsmal,
  },
  {
    label: 'ML (60x90)',
    value: EtikettTypEnum.MLbred,
  },
];

interface IProps {
  bjid: string;
  onClose: () => void;
}

const Etikett: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const rapport = rapportInfos.BJEtikett;
  const userSettings = useReadRapportSettings(rapport.rapportID);
  const doWriteUserSettings = useWriteRapportSettings(rapport.rapportID);

  const [etiketttyp, setEtikettTyp] = useState(
    userSettings['etiketttyp'] ?? 'Kista'
  );
  const writeUserSettings = () => {
    const settings: RapportSettings = {
      etiketttyp: etiketttyp,
    };
    doWriteUserSettings(settings);
  };

  const onRadioChange = (newValue: string) => {
    setEtikettTyp(newValue as EtikettTypEnum);
  };

  const activeDatabaseContext = useContext(ActiveDatabaseContext);
  if (rapport && activeDatabaseContext.activeDatabase) {
    const ExporteraEtikett = () => {
      writeUserSettings();
      RapportQuery({
        db: activeDatabaseContext.activeDatabase || '',
        rapportId: rapport.rapportID,
        rapportParams: {
          ID: props.bjid,
          etiketttyp: etiketttyp !== '' ? etiketttyp : undefined,
          etikettindex:
            etiketttyp !== ''
              ? Object.values(EtikettTypEnum).indexOf(
                  EtikettTypEnum[etiketttyp as keyof typeof EtikettTypEnum]
                )
              : undefined,
        },
      });
    };

    return (
      <StandardRapport
        rapport={rapport}
        onExport={ExporteraEtikett}
        onClose={props.onClose}
        exportDisabled={etiketttyp === ''}
        exportDisabledReason={
          etiketttyp === '' ? 'Typ av etikett måste väljas' : etiketttyp
        }
      >
        <EDTypography variant="body2">Utskrift:</EDTypography>
        <EDGrid container rowSpacing={-1}>
          <EDGrid item sm={6} xs={12}>
            <EDRadioGroup
              radioDefs={radioDefs}
              label="Välj etikett"
              value={
                etiketttyp ? EtikettTypEnum[etiketttyp as keyof typeof EtikettTypEnum] : EtikettTypEnum.Kista
              }
              onChange={onRadioChange}
            />
          </EDGrid>
        </EDGrid>
      </StandardRapport>
    );
  } else return <></>;
};

export default Etikett;
